import { useEffect, useState } from 'react';

export function useSmoothInitialRender(inSecurityFrame?: boolean) {
  // The security frame is initially not ready (see below), but the main page is
  const [ready, setReady] = useState(!inSecurityFrame);

  useEffect(() => {
    if (inSecurityFrame) {
      // Let the content render once, then make the background non-transparent
      // and show the content. This avoids some slight jank as the font loads
      // when it renders the first time. A loader is shown in the main page's
      // StartPage while this is happening, and then gets hidden by the frame's
      // background.
      setTimeout(() => {
        setReady(true);
      }, 250);
    }
  }, [inSecurityFrame]);

  return ready
    ? ({ background: 'background', opacity: 1 } as const)
    : ({ background: 'transparent', opacity: 0 } as const);
}
